import { hasS3Object } from "@/lib/aws-amplify/storage";

import { Converter } from "@/components/features/_shared";
import { convertRequiredPrepMillisecondIntoRequiredPrepMillisecondBeforeDateAndHour } from "@/components/features/_shared/validation-schema/converter";

import { DUMMY_IMAGE } from "@/constants/dummy-image";

import { normalizeOverSiteControllerPeopleNum } from "../../../../_shared/normalize-over-site-controller-people-num";

import type { ProductRoomFormModel } from "../../../../../type";
import type { ServerModel } from "../../type";


export const serverModelToInputModelConverter = (serverModel: ServerModel): ProductRoomFormModel["InputModel"] => {
	const { room, hotelPolicy } = serverModel;

	// 他のアイテムが初期値になりうるプロパティ
	const requiredPrepMillisecond: number = room.requiredPrepMillisecond || hotelPolicy?.requiredPrepMillisecond || 0;
	const amenities = room.amenities ?? hotelPolicy?.amenities ?? [];

	const { requiredPrepMillisecondBeforeDate, requiredPrepMillisecondBeforeHour } =
		convertRequiredPrepMillisecondIntoRequiredPrepMillisecondBeforeDateAndHour(requiredPrepMillisecond);

	const inputModel: ProductRoomFormModel["InputModel"] = {
		availablePlanIDs: room.availablePlanIDs,

		address: room.address ?? undefined,
		beds: room.beds,
		capacityAdultMaximum: room.capacityAdultMaximum,
		capacityKidsMaximum: room.capacityKidsMaximum,
		capacityPeopleMaximum: room.capacityPeopleMaximum,
		catchCopy: room.catchCopy,
		description: room.description,
		geoLocation: room.geoLocation ?? undefined,
		hotelID: room.hotelID,
		inSale: room.inSale,
		isDormitoryType: room.isDormitoryType,
		isShowStockPreview: room.isShowStockPreview ?? false,
		isExtendSiteControllerPeopleNum: room.isExtendSiteControllerPeopleNum,
		isKidsUnavailable: room.isKidsUnavailable,
		isNotDiscountTarget: room.isNotDiscountTarget ?? false,
		keyVisuals: room.keyVisuals ?? [],
		kidsPolicy: room.kidsPolicy?.map(Converter.kidsPolicyItemConverter) ?? undefined,
		/**
		 * 旧版で作成される場合、ダミー画像が設定されない
		 */
		mainKeyVisual: hasS3Object(room.mainKeyVisual) ? room.mainKeyVisual : DUMMY_IMAGE.s3Object,
		maxRoomNum: room.maxRoomNum,
		name: room.name,
		overSiteControllerPeopleNum: normalizeOverSiteControllerPeopleNum(room),
		roomID: room.roomID,
		roomSize: room.roomSize ?? undefined,
		saleTypeForPlan: room.saleTypeForPlan,

		// 他のアイテムが初期値になりうるプロパティ
		amenities,
		requiredPrepMillisecond,

		// InputModel 固有のプロパティ
		requiredPrepMillisecondBeforeDate,
		requiredPrepMillisecondBeforeHour,
	} satisfies ProductRoomFormModel["InputModel"];
	return inputModel;
};
